import { Link } from "react-router-dom";
import { communityTopics } from "@/mocks/community";
import SectionHeading from "@/components/base/SectionHeading";

export default function CommunityHot() {
  const items = communityTopics.slice(0, 5);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <SectionHeading
        eyebrow="社区热点"
        title="正在热议的话题"
        action={
          <Link
            to="/community"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            进入社区
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <ul className="divide-y divide-background-200">
        {items.map((topic, index) => (
          <li key={topic.id}>
            <Link to={`/community/${topic.id}`} className="group flex items-start gap-3 py-3.5">
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  index < 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-2 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                  {topic.title}
                </h3>
                <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-400">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-800">{topic.category}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {topic.replies}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {topic.views}
                  </span>
                  <span>{topic.createdAt}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}